import React from 'react';
import { MessageCircle } from 'lucide-react';
import { track } from '../services/analytics';

/**
 * StickyCTA — floating WhatsApp-style button pinned to bottom-right.
 * Click opens the LeadCaptureModal (via custom event rk:open-lead).
 * Hidden on auth / product routes.
 */
export default function StickyCTA() {
  const [isHidden, setIsHidden] = React.useState(false);

  React.useEffect(() => {
    const pathsToHide = ['/admin', '/manager', '/tenant/onboard'];
    const check = () => setIsHidden(pathsToHide.some((p) => window.location.pathname.startsWith(p)));
    check();
    window.addEventListener('popstate', check);
    // Also re-check on route change (react-router uses pushState)
    const origPush = window.history.pushState;
    window.history.pushState = function (...args) {
      origPush.apply(this, args);
      check();
    };
    return () => {
      window.removeEventListener('popstate', check);
      window.history.pushState = origPush;
    };
  }, []);

  if (isHidden) return null;

  return (
    <button
      type="button"
      data-testid="sticky-lead-cta"
      onClick={() => {
        track('cta_sticky_demo_clicked', { surface: 'public' });
        window.dispatchEvent(new CustomEvent('rk:open-lead', { detail: { source: 'sticky_cta' } }));
      }}
      className="fixed bottom-5 right-5 z-[60] group"
      aria-label="Get a WhatsApp demo"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-400 opacity-60 animate-ping" />
      <span className="relative flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white px-4 py-3 rounded-full shadow-2xl transition-all transform hover:scale-105">
        <MessageCircle size={20} className="fill-white" />
        <span className="hidden sm:inline font-bold text-sm">Get a demo</span>
      </span>
      {/* Tooltip on hover (desktop) */}
      <span className="hidden sm:block absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat with us on WhatsApp
      </span>
    </button>
  );
}
